// @ts-ignore
import { ApiClient } from "../../lib/ApiClient";
import { useGenericSWR } from "../../lib/useGenericSWR";
import { SwrOptions } from "../../lib/useGenericSWR.interfaces";
// @ts-ignore
import { ensureLuxonDate } from '../../lib/Formatters';

const baseUrl = 'api/v1/AggBillingCycleReading';
const apiClient = new ApiClient();

const useAggBillingCycleReadings = (accountId: number | null, uom: string, startDate: unknown, endDate: unknown, classification: string, swrOptions: SwrOptions) => {
    const params = new URLSearchParams();
    params.append('accountId', accountId?.toString() ?? "");
    params.append('uom', uom);
    params.append('startDate', ensureLuxonDate(startDate)?.toUTC().toISO());
    params.append('endDate', ensureLuxonDate(endDate)?.toUTC().toISO());
    params.append('classification', classification);

    return useGenericSWR(
        (accountId === null || startDate === undefined || endDate === undefined) ? null : baseUrl + "/AggBillingCycleReadingsByAccount?" + params.toString(),
        apiClient,
        { ...swrOptions }
    );
};

const useAggBillingCycleReadingsHistorical = (accountId: number | null | undefined, selectedMeter: string, uom: string, startDate: unknown, endDate: unknown, yearOne: number, yearTwo: number, swrOptions: SwrOptions) => {
    const params = new URLSearchParams();
    params.append('accountId', accountId?.toString() ?? "");
    params.append('selectedMeter', selectedMeter?.toString());
    params.append('uom', uom);
    params.append('startDate', ensureLuxonDate(startDate)?.toUTC().toISO());
    params.append('endDate', ensureLuxonDate(endDate)?.toUTC().toISO());
    params.append('yearOne', yearOne?.toString() ?? null);
    params.append('yearTwo', yearTwo?.toString() ?? null);

    return useGenericSWR(
        (accountId === null || selectedMeter === null || startDate === undefined || endDate === undefined || yearOne === null || yearTwo === null) ? null
            : baseUrl + "/AggBillingCycleReadingsHistoricalAccount?" + params.toString(),
        apiClient,
        { ...swrOptions }
    );
};

export {
    useAggBillingCycleReadings,
    useAggBillingCycleReadingsHistorical
};